export enum TEMPERATURE_CONTROL {
  NITROGEN = 'NITRO',
  DEGREES = 'NITRO',
  ICE = 'ICE',
  CORINH = 'CORINH',
}
